import React from 'react';
import styles from './PageContentCardContainer.module.css';
import Card from '../../Card/Card';
import { FCWithChildren } from '../../../App.types';

const PageContentCardContainer: FCWithChildren = ({ children }) => <Card className={styles.container}>{children}</Card>;

export default PageContentCardContainer;
